import type { CSSProperties } from 'react'

/**
 * Runtime values on their way into CSS.
 *
 * The project bans inline styles with one exception: a custom property carrying
 * a value that is only known at runtime, such as a bar's width or a column's
 * measure. This helper is that exception, made typed and made searchable, so a
 * reviewer grepping for `style=` finds a call to `cssVars` and knows the rule
 * was followed on purpose rather than forgotten.
 *
 * The key type is `--${string}`, which is what does the work: passing
 * `{ width: '4rem' }` is a type error, so the escape hatch cannot quietly widen
 * into ordinary inline styling.
 *
 * The double assertion is unavoidable. React's `CSSProperties` deliberately
 * dropped its index signature so that misspelled property names are caught, and
 * the documented consequence is that custom properties need an assertion at the
 * boundary. Doing it once here beats doing it at forty call sites.
 */
export function cssVars(values: Record<`--${string}`, string | number | undefined>): CSSProperties {
  return values as unknown as CSSProperties
}
